import { render, staticRenderFns } from "./CreateLive.vue?vue&type=template&id=3ec2c18d&scoped=true"
import script from "./CreateLive.vue?vue&type=script&lang=js"
export * from "./CreateLive.vue?vue&type=script&lang=js"
import style0 from "./CreateLive.vue?vue&type=style&index=0&id=3ec2c18d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec2c18d",
  null
  
)

export default component.exports